(function () {
  'use strict';

  function loadAndPlay(video) {
    if (!video || !video.dataset.src) return;
    if (video.dataset.loaded !== 'true') {
      var source = document.createElement('source');
      source.src = video.dataset.src;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.dataset.loaded = 'true';
      video.load();
    }
    video.play().catch(function () {});
  }

  function pauseVideo(video) {
    if (video && !video.paused) video.pause();
  }

  document.addEventListener('pointerover', function (event) {
    var card = event.target.closest('.lumi-card');
    if (!card) return;
    loadAndPlay(card.querySelector('[data-card-overlay-video]'));
  });

  document.addEventListener('pointerout', function (event) {
    var card = event.target.closest('.lumi-card');
    if (!card || card.contains(event.relatedTarget)) return;
    pauseVideo(card.querySelector('[data-card-overlay-video]'));
  });

  document.addEventListener('focusin', function (event) {
    var card = event.target.closest('.lumi-card');
    if (!card) return;
    loadAndPlay(card.querySelector('[data-card-overlay-video]'));
  });
})();
